import * as Sentry from '@sentry/react';
import { action, makeObservable, observable } from 'mobx';

import { showError, showInfo, showSuccess } from '@components/toaster';

import { config } from 'app-config';
import { Company } from 'models/companies';
import { I18nStore } from 'models/ui';

export class RootStore {
  // stores
  i18n = I18nStore.create();
  router = null;
  theme = null;

  // companies
  companies = [];
  current = null;

  constructor({ theme, history }) {
    makeObservable(this, {
      current: observable,
      companies: observable,
      setMe: action,
    });

    this.router = history;
    this.theme = theme;
  }

  setMe = (whoami) => {
    const { company, companies, ...rest } = whoami;

    const env = {
      t: this.i18n.t,
      showSuccess: showSuccess,
      showError: showError,
      showInfo: showInfo,
      lang: this.i18n.lang,
      theme: this.theme,
      router: this.router,
    };

    this.companies = companies;
    this.current = Company.create({ id: company.id, whoami: rest }, env);
    this.current.load();
    this.current.loadInfo();

    if (config.MODE === 'production') {
      Sentry.setUser({
        email: rest.email,
        id: rest.id,
        role: rest.role,
      });
    }
  };
}
